import React, { useCallback, createContext, useState, ReactNode } from "react";
import { PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from "./../entidades";

interface IHomeContext {
  salvarPlano: (parametros: PlanoVinculadoEntidade) => void; // eslint-disable-line no-unused-vars
  buscarPlano: () => Promise<PlanoVinculadoEntidade>;

  salvarProcessoBeneficio: (parametros: ProcessoBeneficioEntidade) => void; // eslint-disable-line no-unused-vars
  buscarProcessoBeneficio: () => Promise<ProcessoBeneficioEntidade>;

}
export const HomeContext = createContext<IHomeContext | null>(null);

export const HomeProvider: React.FC = ({ children }) => {

  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>(new PlanoVinculadoEntidade());
  const [ProcessoBeneficio, setProcessoBeneficio] = useState<ProcessoBeneficioEntidade>(new ProcessoBeneficioEntidade());

  /* --- Plano --- */

  const salvarPlano = useCallback(async (parametros) => {
    setPlano(parametros);
  }, []);

  const buscarPlano = useCallback(async () => {
    return Plano;
  }, [Plano]);

  /* --- ProcessoBeneficio --- */

  const salvarProcessoBeneficio = useCallback(async (parametros) => {
    setProcessoBeneficio(parametros);
  }, []);

  const buscarProcessoBeneficio = useCallback(async () => {
    return ProcessoBeneficio;
  }, [ProcessoBeneficio]);

  return (
    <HomeContext.Provider value={{
      salvarPlano, buscarPlano,

      salvarProcessoBeneficio, buscarProcessoBeneficio,
    }}>
      {children}
    </HomeContext.Provider>
  );
}
